const doc = [({"en":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"rule":({"attribute_select":({"choose_attribute":"Choose attribute"})})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;